/**
 * Created by Mark on 21/04/2017.
 */
import Translation from '../store/internationalization-store.js';
const MonthTranslationKeys = {'01':'ui-617' , '02':'ui-618' , '03':'ui-619' , '04':'ui-620' , '05':'ui-621' , '06':'ui-622' , '07':'ui-623' , '08':'ui-624' , '09':'ui-625' , '10':'ui-626' , '11':'ui-627' , '12':'ui-628'};

class  DateHelper {

    getMonthTranslation(month) {
        console.log("here");
        return Translation.getTranslation(MonthTranslationKeys[month], MonthTranslationKeys[month]);
    }

    getToday() {
        var d = new Date();
        return d.toISOString();
    }

    getDaysInPast(days) {
        var d = new Date();
        var due = new Date();
        due.setDate(due.getDate() + days);
        return due.toISOString();
    }

    getInMonths(months) {
        function addMonthsUTC(date, count) {
            if (date && count) {
                var m, d = (date = new Date(+date)).getUTCDate()

                date.setUTCMonth(date.getUTCMonth() + count, 1)
                m = date.getUTCMonth()
                date.setUTCDate(d)
                if (date.getUTCMonth() !== m) date.setUTCDate(0)
            }
            return date
        }

        return addMonthsUTC(Date.now(), months)
    }

    getAllMonths() {
        return Object.keys(MonthTranslationKeys).map(function (key) {
            return Translation.getTranslation(MonthTranslationKeys[key], 'month');
        });
    }

    getDate(dateStr){
        var a=dateStr.split(" ");
        var d=a[0].split("-");
        var t=a[1].split(":");
        return new Date(d[0],(d[1]-1),d[2],t[0],t[1],t[2]);
    }

    format(dateStr) {


        //var dateStr="2011-08-03 09:15:11"; //returned from mysql timestamp/datetime field
        var a=dateStr.split(" ");
        var d=a[0].split("-");
        var t=a[1].split(":");
        var myDate = new Date(d[0],(d[1]-1),d[2],t[0],t[1],t[2]);

        function pad(n, width, z) {
            z = z || '0';
            n = n + '';
            return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        }

        return pad(myDate.getDate() ,  2) + "-" + pad((myDate.getMonth() + 1) , 2 ) + "-" + myDate.getFullYear().toString().substr(-2);;
    }
}

export default DateHelper;